var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.inited
        ? _c("c-loader", { attrs: { active: !_vm.inited, height: 100 } })
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.inited,
              expression: "inited",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "form-group field-form__type" },
            [
              !_vm.customFields.length
                ? _c("div", { staticClass: "empty" }, [
                    _vm._v("Созданных полей пока нет"),
                  ])
                : _c("c-select", {
                    attrs: {
                      type: "select",
                      "floating-label": "Расположение поля",
                      "required-mark": true,
                      searchable: true,
                      items: _vm.customFields,
                      groups: _vm.customFieldsGroups,
                      required: _vm.isSubmitted && _vm.originalError,
                      "required-message": _vm.isSubmitted && _vm.originalError,
                    },
                    model: {
                      value: _vm.original,
                      callback: function ($$v) {
                        _vm.original = $$v
                      },
                      expression: "original",
                    },
                  }),
            ],
            1
          ),
          _vm.original && !_vm.loaded
            ? _c("c-loader", { attrs: { active: !_vm.loaded, height: 100 } })
            : _vm._e(),
          _c("custom-form", {
            ref: "form",
            attrs: {
              inited: _vm.loaded,
              "is-copy": true,
              form: _vm.form,
              "is-submitted": _vm.isSubmitted,
              warning: _vm.showWarning,
            },
            on: {
              submit: _vm.submit,
              changeDictionary: function ($event) {
                _vm.changedDictionary = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }